import moment from 'moment';
import { useState } from 'react';

import Card from 'react-bootstrap/Card';
import CardSubtitle from 'react-bootstrap/CardSubtitle';
import Toast from 'react-bootstrap/Toast';
import ToastContainer from 'react-bootstrap/ToastContainer';
import { BsArrowRight, BsDownload, BsBoxArrowUpRight, BsCopy } from 'react-icons/bs';
import { flattenToAppURL } from '@plone/volto/helpers';

import './less/ResourceCard.less';

const ResourceCard = ({
  id,
  title,
  description,
  date,
  related_info,
  links_download,
  categories,
}) => {
  const [showToast, setShowToast] = useState(false);
  const formattedDate = moment(date).format('D MMMM YYYY');

  const handleCopyUrl = () => {
    // Construir la URL completa para compartir
    const baseUrl = window.location.origin;
    const resourceUrl = `${baseUrl}${flattenToAppURL(id)}`;

    if (resourceUrl) {
      navigator.clipboard.writeText(resourceUrl).then(() => {
        // Mostrar toast de confirmación
        setShowToast(true);
        console.log('URL del recurso copiada al portapapeles:', resourceUrl);
      }).catch(err => {
        console.error('Error al copiar URL:', err);
      });
    } else {
      console.warn('No se pudo obtener la URL del recurso para copiar.');
    }
  };

  return (
    <>
      <Card key={id} className="resource-card text-bg-light border-0 mb-4">
        <Card.Body>
          {/* <Card.Text className="text-muted mb-1">{formattedDate}</Card.Text> */}
          <div className="d-flex justify-content-between align-items-start mb-3">
            <Card.Text className="card-title fw-bold mb-0">{title}</Card.Text>
            <div style={{ position: 'relative' }}>
              <button
                onClick={handleCopyUrl}
                className="btn btn-link p-0 ms-2"
                title="Copy URL"
                style={{ border: 'none', background: 'none' }}
              >
                <BsCopy className="text-muted ms-3" />
              </button>

              {/* Toast de confirmación */}
              <ToastContainer position="bottom-start" className="p-3">
                <Toast
                  show={showToast}
                  onClose={() => setShowToast(false)}
                  delay={3000}
                  autohide
                  bg="success"
                  text="white"
                  style={{
                    position: 'absolute',
                    top: 'calc(100% + 5px)',
                    right: '0',
                    zIndex: 1000,
                    minWidth: '200px'
                  }}
                >
                  <Toast.Header closeButton>
                    <strong className="me-auto">URL copied!</strong>
                  </Toast.Header>
                </Toast>
              </ToastContainer>
            </div>
          </div>
          <Card.Text>{description}</Card.Text>
          {related_info && related_info.length > 0 && (
            <>
              <hr className="hr pt-3" />
              <CardSubtitle className="mb-3">RELATED INFO</CardSubtitle>
              {related_info.map(
                (item) =>
                  item && (
                    <p className="mb-2">
                      <BsArrowRight className="me-2" />
                      <a
                        href={item['@id']}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {item.title}
                      </a>
                    </p>
                  ),
              )}
            </>
          )}
          {/* <hr className="hr pt-3" />
          <CardSubtitle className="mb-3">CATEGORIES</CardSubtitle>
          {categories &&
            categories.length > 0 &&
            categories.map((item) => (
              <a className="ui label" href={`/search-unite?Subject=${item}`}>
                {item}
              </a>
            ))} */}
          {links_download && links_download.length > 0 && (
            <>
              <hr className="hr pt-3" />
              <CardSubtitle className="mb-3">LINKS & DOWNLOADS</CardSubtitle>
              <div className="d-flex flex-wrap">
                {links_download.map(
                  (item) =>
                    item && (
                      <a
                        href={
                          item['@type'] === 'File'
                            ? `${item['@id']}/@@download/file?utm_source=unite-website&utm_medium=resources&utm_campaign=${item['title']}&utm_id=file-download`
                            : `${item['@id']}?utm_source=unite-website&utm_medium=resources&utm_campaign=${item['title']}&utm_id=file-download`
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                        className="ui label reverse d-flex align-items-center"
                      >
                        {item['@type'] === 'File' ? (
                          <BsDownload className="me-2 flex-shrink-0" />
                        ) : (
                          <BsBoxArrowUpRight className="me-2 flex-shrink-0" />
                        )}{' '}
                        {item.title}
                      </a>
                    ),
                )}
              </div>
            </>
          )}
        </Card.Body>
      </Card>
    </>
  );
};

export default ResourceCard;
